import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const TRANSLATION_EDIT_FORM_SCHEMA = yup.object().shape({
  key: yup.string().required('Molimo Vas da unesete key'),
  value: yup.string().required('Molimo Vas da unesete value'),
});

